import React, { useCallback } from 'react';
// @ts-ignore
import { Modal } from '@pwc/appkit-react/lib/Modal';

import bookToTaxCodesColumnDefinitions from '../../shared/columnDefinitions/bookToTaxCodes';
import ViewGrid from '../shared/viewGrid.component';
import Button from '../../shared/button.component';

type BookToTaxCodesModalProps = {
  isBookToTaxModalOpen: boolean;
  closeBookToTaxCodesModal: () => void;
  isLoadingBookToTaxCodes: boolean;
  bookToTaxCodes: {
    countryTaxType: string;
    linkedFlag: number;
    periodName: string;
    tagCode: string;
    tagDescription: string;
  }[],
  isExportingBookToTaxCodes: boolean,
  exportBookToTaxCodes: () => void,
}

const BookToTaxCodesModal = ({
  isBookToTaxModalOpen,
  closeBookToTaxCodesModal,
  isLoadingBookToTaxCodes,
  bookToTaxCodes,
  isExportingBookToTaxCodes,
  exportBookToTaxCodes,
}: BookToTaxCodesModalProps) => {
  const renderBookToTaxCodesGrid = useCallback(() => (
    <ViewGrid
      className="book-to-tax-codes-grid"
      columnDefs={bookToTaxCodesColumnDefinitions}
      data={bookToTaxCodes}
      isLoading={isLoadingBookToTaxCodes}
      shouldDisplayAdminColumn={false}
    />
  ), [bookToTaxCodes, isLoadingBookToTaxCodes]);

  return (
    <Modal
      className="book-to-tax-codes-wrapper"
      visible={isBookToTaxModalOpen}
      onCancel={closeBookToTaxCodesModal}
      zIndex={90000}
    >
      <div className="book-to-tax-codes-modal-content">
        <div className="modal-controls">
          <button
            type="button"
            className="close close-button"
            onClick={closeBookToTaxCodesModal}
          >
            <span>&times;</span>
          </button>
        </div>

        <div className="row no-gutters page-content-container">
          <div className="col">
            <div className="d-flex flex-row justify-content-between">
              <h5>Book to Tax Code Descriptions</h5>
            </div>
          </div>
        </div>

        <div className="grid-controls">
          <Button
            onClick={exportBookToTaxCodes}
            disabled={isLoadingBookToTaxCodes}
            kind="primary"
            isLoading={isExportingBookToTaxCodes}
          >
            Export to Excel
          </Button>
        </div>
        {renderBookToTaxCodesGrid()}
      </div>
    </Modal>
  );
};

export default BookToTaxCodesModal;
